module.exports = __webpack_public_path__ + "img/couples_01_V.550ce13a.webp";